// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card{-webkit-box-shadow:0 2px 1px -1px transparent,0 1px 1px 0 transparent,0 1px 3px 0 transparent;box-shadow:0 2px 1px -1px transparent,0 1px 1px 0 transparent,0 1px 3px 0 transparent}", ""]);
// Exports
module.exports = exports;
